module.exports = __webpack_public_path__ + "img/champion-betting-vn.d0faf6de.gif";